import React from 'react';

class DataGridRow extends React.Component {
    render () {
        return (
            <div {...this.props} className={['component-data-grid-row', this.props.className].join(' ')}>
                { this.props.children }
            </div>
        )
    }
}

export default DataGridRow;



// WEBPACK FOOTER //
// ./web-app/components/data-grid-row.jsx